import { render, staticRenderFns } from "./ExportInvoices.vue?vue&type=template&id=96d557f8&"
import script from "./ExportInvoices.vue?vue&type=script&lang=js&"
export * from "./ExportInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports